import { ClientType, getCurrentClientType, userTypeKeysToEnum } from "./clientTypeUtils";

const logoStatus = Object.freeze({
  NOT_EMPTY: "NOT_EMPTY",
  EMPTY: 'Empty',
  NOT_QUALIFIED: "NOT_QUALIFIED"
});

const getCurrentUserTypeIdObject = currentUser => {
  switch (currentUser?.user_type) {
    case ClientType.HEALTH_SYSTEM:
      return {
        health_system_id: currentUser.health_system_id?.id,
      };
    case ClientType.HOSPITAL:
      return {
        hospital_id: currentUser.hospital_id?.id,
      };
    case ClientType.DEPARTMENT:
      return {
        department_id: currentUser.department_id?.id,
      };
    case ClientType.PROVIDER:
      return {
        provider_id: currentUser.provider_id?.providers__id,
      };

    case ClientType.PHYSICIANS_GROUP:
      return {
        health_system_id: currentUser.physicians_group_id?.id,
      };
    default:
      return {};
  }
};

const getCurrentUserTypeId = currentUser => {
  switch (currentUser?.user_type) {
    case 'HEALTH SYSTEM':
      return currentUser.health_system_id?.id;
    case 'HOSPITAL':
      return currentUser.hospital_id?.id;
    case 'DEPARTMENT':
      return currentUser.department_id?.id;
    case 'PROVIDER':
      return currentUser.provider_id?.providers__id;

    case 'PHYSICIANS GROUP':
      return currentUser.physicians_group_id?.id;
    default:
      return {};
  }

};

const getCurrentUserTypeName = currentUser => {
  switch (currentUser?.user_type) {
    case 'HEALTH SYSTEM':
      return currentUser.health_system_id?.name || '';

    case 'HOSPITAL':
      return currentUser.hospital_id?.name || '';

    case 'DEPARTMENT':
      return currentUser.department_id?.specialty__name || '';

    case 'PROVIDER':
      return currentUser.provider_id?.name || '';

    case 'PHYSICIANS GROUP':
      return currentUser.physicians_group_id?.name || '';
    default:
      return '';
  }
};

const getCurrentUserTypeLogo = currentUser => {
  if (!currentUser) {
    return null;
  }
  const userType = getCurrentClientType(currentUser.user_type ?? currentUser.type);
  switch (userType) {
    case ClientType.HEALTH_SYSTEM:
      return currentUser.health_system_id?.logo || '';

    case ClientType.HOSPITAL:
      return currentUser.hospital_id?.logo || '';

    case ClientType.PHYSICIANS_GROUP:
      return currentUser.physicians_group_id?.logo || '';
      
      // For future reference. As of now only health_system and hospital has logos
    // case ClientType.DEPARTMENT:
    //   return currentUser.department_id?.specialty__name || '';

    // case ClientType.PHYSICIAN:
    //   return currentUser.provider_id?.name || '';

    default:
      return null;
  }
};

const isCurrentUserLogoQualified = currentUser => {
  if (!currentUser) {
    return null;
  }
  const userType = getCurrentClientType(currentUser.user_type ?? currentUser.type);
  return [ClientType.HEALTH_SYSTEM, ClientType.HOSPITAL, ClientType.PHYSICIANS_GROUP].includes(userType);
};

// for returning status with logo value
const getCurrentUserTypeLogoDetails = currentUser => {
  const logo = getCurrentUserTypeLogo(currentUser);
  if (logo == '') {
    return [logoStatus.EMPTY, null];
  }
  if (!logo) {
    return [logoStatus.NOT_QUALIFIED, null];
  }

  return [logoStatus.NOT_EMPTY, logo];
}

// returns all related client types enums for this client. As of now frontend is not comaptible for a client to be related
// to more than 1 health_system, hospitals, departments or physicians
const getAllRelatedClientTypes = currentUser => {
  const relatedTypes = [];
  for (const key in userTypeKeysToEnum) {
    if (key in currentUser) {
      relatedTypes.push(userTypeKeysToEnum[key]);
    }
  }

  return relatedTypes;
}



export { getCurrentUserTypeIdObject as getCurrentUserTypeIdObject,
        getCurrentUserTypeName, 
        getCurrentUserTypeLogo, 
        getCurrentUserTypeLogoDetails,
        isCurrentUserLogoQualified,
        getCurrentUserTypeId, 
        getAllRelatedClientTypes,
        logoStatus
      };
